import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AdminMenu from "../../AdminMenu";

import {
  GoogleMap,
  useLoadScript,
  Marker,
  Polygon,
  Autocomplete
} from "@react-google-maps/api";

import { Button } from "primereact/button";
import { GoogleMapsApiKey } from "../../../constants/FormateDate";
import { getUserData } from "../../../utils/localStorage";
import { addBrandStorePolygon, searchStorePolygon, updateBrandStorePolygon } from "../../../services/StoreUsers/PostStoreUsers";
import { FloatLabel } from "primereact/floatlabel";
import { InputText } from "primereact/inputtext";
import SuccessModal from "../../SuccessModal";

const DEFAULT_CENTER = { lat: 28.6139, lng: 77.2090 };
const LIBRARIES = ["marker", "places"]; // static, prevents reload warning

const GeoLocationView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id, StoreData } = location.state || {}; // Fallback to prevent undefined errors

  const { userProfileRole, brandProfileData } = getUserData();
  const userRole = userProfileRole;
  let brandId = brandProfileData.id;

  const [editPolygonData, setEditPolygonData] = useState([]);

  const editPolygonInfo = editPolygonData?.[0];

  const autocompleteRef = useRef(null);

  const [visible, setVisible] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [isButtonPressed, setIsButtonPressed] = useState(false)
  const [zoneName, setZoneName] = useState("")

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: GoogleMapsApiKey,
    libraries: LIBRARIES,
  });

  const [userLocation, setUserLocation] = useState(DEFAULT_CENTER);
  const [points, setPoints] = useState([]); // points while drawing
  const [polygon, setPolygon] = useState(null); // saved polygon
  const [finishPolygonView, setFinishPolygonView] = useState(false);

  // for edit pass saved data in ploygon 

  // const [points, setPoints] = useState([
  //   {
  //     "lat": 28.675366750952335,
  //     "lng": 77.32454241679729
  //   },
  //   {
  //     "lat": 28.62896936031824,
  //     "lng": 77.32248248027385
  //   },
  //   {
  //     "lat": 28.633188153120464,
  //     "lng": 77.3911470310551
  //   },
  //   {
  //     "lat": 28.642529162209357,
  //     "lng": 77.41723956035197
  //   },
  //   {
  //     "lat": 28.637105451726192,
  //     "lng": 77.46118487285197
  //   },
  //   {
  //     "lat": 28.67868006456678,
  //     "lng": 77.38428057597697
  //   },
  //   {
  //     "lat": 28.675366750952335,
  //     "lng": 77.32454241679729
  //   }
  // ])


  // const [polygon, setPolygon] = useState([
  //   {
  //     "lat": 28.662886930481026,
  //     "lng": 77.39156774590558
  //   },
  //   {
  //     "lat": 28.64691941324189,
  //     "lng": 77.40186742852276
  //   },
  //   {
  //     "lat": 28.652041334608807,
  //     "lng": 77.42143682549542
  //   },
  //   {
  //     "lat": 28.671321618158643,
  //     "lng": 77.40804723809308
  //   },
  //   {
  //     "lat": 28.662886930481026,
  //     "lng": 77.39156774590558
  //   },
  // ]); // saved polygon

  const mapRef = useRef(null);

  const onPlaceChanged = () => {
    const place = autocompleteRef.current.getPlace();

    if (!place.geometry) return;

    const location = place.geometry.location;

    const newCenter = {
      lat: location.lat(),
      lng: location.lng(),
    };

    setUserLocation(newCenter);

    // smooth pan
    if (mapRef.current) {
      mapRef.current.panTo(newCenter);
    }
  };

  // Get user's current location
  useEffect(() => {
    const data = {
      storeId: id
    }
    searchStorePolygon(data)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setEditPolygonData(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });

    if (navigator.geolocation) {
      if (StoreData?.address?.latitude) {
        setUserLocation(
          {
            lat: StoreData?.address?.latitude,
            lng: StoreData?.address?.longitude,
          })
      } else {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            setUserLocation({
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            });
          },
          (error) => {
            console.error("Error getting location:", error);
            setUserLocation(DEFAULT_CENTER);
          }
        );
      }
    }
  }, []);

  useEffect(() => {
    if (editPolygonData?.length > 0) {
      const removeLastPoint = editPolygonInfo?.coordinates.pop();
      const newMapPolygon = editPolygonInfo?.coordinates.map(point => ({
        lat: point?.[1],
        lng: point?.[0]
      }));
      setPoints(newMapPolygon)
      setPolygon([...newMapPolygon]);
    }
  }, [editPolygonData, editPolygonInfo])


  // Handle clicks to add points
  const handleMapClick = (e) => {
    setPoints((prev) => [
      ...prev,
      { lat: e.latLng.lat(), lng: e.latLng.lng() },
    ]);
  };

  // Finish polygon
  const finishPolygon = () => {
    if (points.length < 3) {
      alert("Polygon needs at least 3 points!");
      return;
    }

    setPolygon([...points]);
    setPoints([]);
    setFinishPolygonView(true);

    // Optionally fit map to polygon bounds
    if (mapRef.current) {
      const bounds = new window.google.maps.LatLngBounds();
      points.forEach((p) => bounds.extend(p));
      mapRef.current.fitBounds(bounds);
    }
  };

  // Remove polygon
  const removePolygon = () => {
    setPolygon(null);
  };

  // Undo last point
  const undoPoint = () => {
    setPoints((prev) => prev.slice(0, -1));
  };

  if (!isLoaded) return <div>Loading map...</div>;

  const handleSubmit = () => {

    // Logic for creating a new pickup request
    if (!isButtonPressed) {
      // Set the state to indicate that the button has been pressed
      setIsButtonPressed(true);

      const data = {
        coordinates: polygon.map(point => [point.lng, point.lat]),
        brandId: brandId,
        storeId: id,
        name: zoneName
      };


      const updateData = {
        id: editPolygonInfo?.id,
        coordinates: polygon.map(point => [point.lng, point.lat]),
      };

      // Call the service function for creating pickup request

      if (editPolygonData?.length > 0) {
        updateBrandStorePolygon(updateData)
          .then((response) => {
            if (!response.data.error) {
              const Res = response.data;
              if (Res) {
                const message = Res.message;
                const status = Res.status;
                // sendResponse({message, status, modalFun: false});
                // Reset state variables
                if (status === true) {

                  setModalVisible(true);
                  setModalStatus("success");
                  setModalText(message);
                  setTimeout(() => {
                    navigate("/StoreManagementList");
                  }, 1500);
                  setIsButtonPressed(false);
                } else {
                  setModalVisible(true);
                  setModalStatus("failed");
                  setModalText(message);
                  setIsButtonPressed(false);
                }
              }
            }
          })
          .catch((err) => {
            console.error("Error:", err);
          });
      } else {
        addBrandStorePolygon(data)
          .then((response) => {
            if (!response.data.error) {
              const Res = response.data;
              if (Res) {
                const message = Res.message;
                const status = Res.status;
                // sendResponse({message, status, modalFun: false});
                // Reset state variables
                if (status === true) {

                  setModalVisible(true);
                  setModalStatus("success");
                  setModalText(message);
                  setTimeout(() => {
                    navigate("/StoreManagementList");
                  }, 1500);
                  setIsButtonPressed(false);
                } else {
                  setModalVisible(true);
                  setModalStatus("failed");
                  setModalText(message);
                  setIsButtonPressed(false);
                }
              }
            }
          })
          .catch((err) => {
            console.error("Error:", err);
          });
      }


    }
  }

  return (
    <div className="flex flex-column h-full">
      {/* Header */}
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{ "--surface-0": "#1752AA" }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/StoreManagementList")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">Geo Location</p>
            </div>
          </div>
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      {/* Main Layout */}
      <div className="flex flex-1 p-4 gap-4">

        {/* MAP SECTION */}
        {/* 🗺️ MAP CARD */}
        <div
          className="flex-1 border-round-xl shadow-3 overflow-hidden"
          style={{
            background: "#fff",
            position: "relative",
          }}
        >
          <div style={{ position: "absolute", top: 10, left: 10, zIndex: 10 }}>
            <Autocomplete
              onLoad={(ref) => (autocompleteRef.current = ref)}
              onPlaceChanged={onPlaceChanged}
            >
              <input
                type="text"
                placeholder="Search location..."
                style={{
                  width: "260px",
                  height: "40px",
                  padding: "0 12px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                  outline: "none",
                }}
              />
            </Autocomplete>
          </div>

          <GoogleMap
            zoom={15}
            center={userLocation}
            mapContainerStyle={{ height: "450px", width: "100%" }}
            onClick={handleMapClick}
            onLoad={(map) => (mapRef.current = map)}
          >
            <Marker
              position={userLocation}
              icon={{
                url: "http://maps.google.com/mapfiles/ms/icons/blue-dot.png",
              }}
            />

            {points.map((p, i) => (
              <Marker key={i} position={p} />
            ))}

            {polygon && polygon.length > 2 && (
              <Polygon
                path={polygon}
                options={{
                  fillColor: "#2196F3",
                  fillOpacity: 0.25,
                  strokeColor: "#0D47A1",
                  strokeWeight: 2,
                }}
              />
            )}
          </GoogleMap>
        </div>

        {/* CONTROL PANEL */}
        <div
          className="surface-card border-round shadow-3 p-4 flex flex-column gap-4"
          style={{ width: "320px" }}
        >
          {editPolygonData.length === 0 &&
            <>
              <h3 className="m-0 text-primary">Zone Controls</h3>
              <FloatLabel>
                <InputText
                  id="zoneName"
                  value={zoneName}
                  onChange={(e) => setZoneName(e.target.value)}
                  className="w-full"
                />
                <label htmlFor="zoneName">Zone Name</label>
              </FloatLabel>
            </>
          }

          {/* Buttons */}
          <div className="flex flex-column gap-2">
            {points.length > 2 && (
              <Button
                label="Finish Polygon"
                icon="pi pi-check"
                onClick={finishPolygon}
                className="p-button-success"
              />
            )}

            {points.length >= 1 && (
              <Button
                label="Undo Last Point"
                icon="pi pi-undo"
                onClick={undoPoint}
                className="p-button-warning"
              />
            )}

            {polygon?.length > 0 && (
              <Button
                label="Remove Polygon"
                icon="pi pi-trash"
                onClick={removePolygon}
                className="p-button-danger"
              />
            )}
            {polygon?.length > 0 && finishPolygonView && (



              <Button
                label={editPolygonData?.length > 0 ? "Update Polygon" : "Save Polygon"}
                icon="pi pi-save"
                onClick={handleSubmit}
                className="p-button-primary"
                disabled={isButtonPressed}
              />

            )}
          </div>

          {/* Polygon Points Preview */}
          {polygon?.length > 0 && (
            <div
              className="p-3 border-round surface-100"
              style={{ maxHeight: "200px", overflowY: "auto" }}
            >
              <h4 className="mt-0 mb-2">Points</h4>
              {polygon.map((p, i) => (
                <div key={i} className="text-sm mb-1">
                  #{i + 1}: {p.lat.toFixed(4)}, {p.lng.toFixed(4)}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={modalStatus}
        text={modalText}
      />

      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default GeoLocationView;